import React, { useState, useEffect } from "react";
import { loginPagesText } from "../CommonJquery/WebsiteText";
import Loader from "./Loader.js";
import {
  APL_LINK,
  server_post_data,
  login_to_admin,
} from "../ServiceConnection/serviceconnection.js";
import {
  handleEmailChange,
  handlePasswordChange,
  check_vaild_save,
  combiled_form_data,
} from "../CommonJquery/CommonJquery";
import { Link } from "react-router-dom";
import {
  decryptData,
  encryptData,
  storeData,
} from "../LocalConnection/LocalConnection.js";
import { useNavigate } from "react-router-dom";
import logoIcon from "../assets/uprestroLogo.png";
import Cookies from "js-cookie";
import CryptoJS from "crypto-js";

function Login() {
  const navigate = useNavigate();
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const decryptEmail = (encryptedEmail) => {
    const encrypted = CryptoJS.AES.decrypt(encryptedEmail, "secret_key");
    const decryptedEmail = encrypted.toString(CryptoJS.enc.Utf8);
    const [email, salt] = decryptedEmail.split("::");
    return email;
  };

  const encryptPassword = (password) => {
    const salt = CryptoJS.lib.WordArray.random(128 / 8);
    const passwordWithSalt = password + "::" + salt.toString(CryptoJS.enc.Hex);
    const encryptedPassword = CryptoJS.AES.encrypt(
      passwordWithSalt,
      "secret_key",
    ).toString();
    return encryptedPassword;
  };

  const decryptPassword = (encryptedPassword) => {
    const encrypted = CryptoJS.AES.decrypt(encryptedPassword, "secret_key");
    const decryptedEmail = encrypted.toString(CryptoJS.enc.Utf8);
    const [passwordWithSalt, salt] = decryptedEmail.split("::");
    const password = passwordWithSalt.split("::")[0];
    return password;
  };

  const handleSaveChangesdynamic = async (form_data, url_for_save) => {
    let vaild_data = check_vaild_save(form_data);
    if (vaild_data) {
      setshowLoaderAdmin(true);
      let fd_from = combiled_form_data(form_data, null);
      await server_post_data(url_for_save, fd_from)
        .then((Response) => {
          console.log(Response);
          if (Response.data.error) {
            const invalidElement =
              document.getElementsByClassName("invalid_data")[0];
            if (invalidElement) {
              invalidElement.innerHTML = Response.data.message;
              invalidElement.style.display = "block";
            }
          } else {
            const decrypted = decryptData(Response.data.message);
            let Response_data = decrypted.data_admin;
            let Response_designation = decrypted.data_designation;
            let tokens = decrypted.tokens || {};
            storeData("admin_id", encryptData(Response_data.primary_id));
            let show_mr = "";
            if (Response_data.admin_gender === "Male") {
              show_mr = "Mr. ";
            } else if (Response_data.admin_gender === "Female") {
              show_mr = "Ms. ";
            }
            storeData(
              "admin_name_with_gender",
              encryptData(show_mr + Response_data.admin_name),
            );
            storeData(
              "designation_name",
              encryptData(Response_designation.designation_name),
            );

            storeData(
              "access_permission",
              encryptData(Response_designation.access_permission),
            );
            storeData("access_token", tokens.access);
            storeData("refresh_token", tokens.refresh);
            /*Restaurant Data*/

            if (rememberMe) {
              const encryptedEmail = CryptoJS.AES.encrypt(
                Response_data.admin_email,
                "secret_key",
              ).toString();
              const encryptedPassword = encryptPassword(
                Response_data.admin_password,
              );

              Cookies.set("email", encryptedEmail, { expires: 30 });
              Cookies.set("password", encryptedPassword, {
                expires: 30,
              });
            } else {
              Cookies.remove("email");
              Cookies.remove("password");
            }

            /*Restaurant Data*/
            navigate("/Dashboard");
          }
          setshowLoaderAdmin(false);
        })
        .catch((error) => {
          console.log(error);
          setshowLoaderAdmin(false);
        });
    }
  };

  // Handle Enter key press
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSaveChangesdynamic("loginFormData", login_to_admin);
    }
  };

  useEffect(() => {
    const email = Cookies.get("email");
    const password = Cookies.get("password");

    if (email && password) {
      const decryptedEmail = decryptEmail(email);
      const decryptedPassword = decryptPassword(password);

      if (decryptedEmail && decryptedPassword) {
        document.getElementsByName("useremail")[0].value = decryptedEmail;
        document.getElementsByName("userpassword")[0].value = decryptedPassword;
        setRememberMe(true);
      }
    }
  }, [rememberMe]);

  const [showPassword, setShowPassword] = useState(false);

  console.log(loginPagesText.forgotPass);
  return (
    <div className="login">
      {showLoaderAdmin && <Loader />}
      <div className="login_container">
        <div className="row h-100 m-0">
          <div className="col-lg-7 p-0">
            <div className="loginLeft">
              <div className="loginText">
                <img src={logoIcon} alt="Uprestro" />
                <h5>
                  Manage with Ease – Oversee, Optimize, and Elevate with
                  Uprestro Admin
                </h5>

                <Link to="https://www.uprestro.com/">
                  <button style={{ fontWeight: "500" }}>
                    www.uprestro.com
                  </button>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-lg-5 p-0">
            <div className="loginRight">
              <div className="loginFormCol h-100 col-xl-7 col-lg-8 col-md-6 col-11">
                <form id="loginFormData" onKeyPress={handleKeyPress}>
                  <div className="loginFormContainer">
                    <h5>{loginPagesText.logingetstarted}</h5>
                    <span className="invalid_data"></span>
                    <div className="loginInputs">
                      <div className="email_image image_icon_position">
                        <input
                          type="text"
                          name="useremail"
                          placeholder="Email Address"
                          className="trio_email trio_mandatory form-control input_field_custom"
                          maxLength={75}
                          minLength={3}
                          onInput={(e) => handleEmailChange(e)}
                          onKeyPress={handleKeyPress}
                          autoFocus
                          tabIndex={1}
                        />
                        <span className="condition_error"></span>
                      </div>
                      <div className="password_image image_icon_position">
                        <input
                          type={showPassword ? "text" : "password"}
                          name="userpassword"
                          placeholder="Password"
                          maxLength={40}
                          minLength={3}
                          className="trio_password trio_mandatory form-control input_field_custom"
                          onInput={(e) => handlePasswordChange(e)}
                          onKeyPress={handleKeyPress}
                          tabIndex={2}
                        />
                        <span
                          className="eye_icon"
                          onClick={() => setShowPassword(!showPassword)}
                          tabIndex={3}
                        >
                          {showPassword ? (
                            <div className="eye_open"></div>
                          ) : (
                            <div className="eye_close"></div>
                          )}
                        </span>
                        <span className="condition_error"></span>
                      </div>
                    </div>
                    <button
                      style={{ color: "black" }}
                      className="loginBtn"
                      type="button"
                      onClick={() =>
                        handleSaveChangesdynamic(
                          "loginFormData",
                          login_to_admin,
                        )
                      }
                      tabIndex={4}
                    >
                      {loginPagesText.login}
                    </button>
                    <div className="forgetRem">
                      <div className="rememberMe">
                        <input
                          type="checkbox"
                          id="myCheckbox"
                          className="hidden-checkbox"
                          style={{
                            color: "#666666",
                          }}
                          tabIndex={5}
                          checked={rememberMe}
                          onChange={() => setRememberMe(!rememberMe)}
                        />
                        <label
                          htmlFor="myCheckbox"
                          className="checkbox-label"
                          tabIndex={6}
                        >
                          <p
                            style={{
                              color: "#666666",
                            }}
                          >
                            {loginPagesText.rememberMe}
                          </p>
                        </label>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
